<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="pg" class="form-label">Party Group</label>
              <select class="form-control" id="pg" v-model="entity.partyGroup">
                <option value=""></option>
                <option v-for="(opt, i) in partyGroups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="psg" class="form-label">Party Sub-Group</label>
              <select class="form-control" id="psg" v-model="entity.partySubgroup">
                <option value=""></option>
                <option v-for="(opt, i) in partyGroups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="party-cat" class="form-label">Category *</label>
              <select class="form-control" id="party-cat" v-model="entity.category">
                <option value=""></option>
                <option value="SP">Service Provider</option>
                <option value="CORP">Corporate</option>
                <option value="OFFICE">Office</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Address</label>
              <autocomplete
                :dataset="addresses"
                title="Search and select an existing address"
                placeHolder="Type to search"
                :initVal="entity.address"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectAddress"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="party-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="party-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="party-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="party-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="party-qual" class="form-label">Quality score</label>
              <input title="0-100" data-toggle="tooltip" type="number" min="0" max="100" step="1" class="form-control" id="party-qual" v-model="entity.qualityScore"/>
            </div>
            <div class="form-group">
              <label for="party-pref" class="form-label">Preference score</label>
              <input title="0-100" data-toggle="tooltip" type="number" min="0" max="100" step="1" class="form-control" id="party-pref" v-model="entity.preferenceScore"/>
            </div>
            <div class="form-group">
              <label for="party-email" class="form-label">Email</label>
              <input type="text" class="form-control" id="party-email" v-model="entity.email"/>
            </div>
            <div class="form-group">
              <label for="party-fax" class="form-label">Fax</label>
              <input type="text" class="form-control" id="party-fax" v-model="entity.fax"/>
            </div>
            <div class="form-group">
              <label for="party-phone" class="form-label">Mobile Phone</label>
              <input type="text" class="form-control" id="party-phone" v-model="entity.mobilePhone"/>
            </div>
            <div class="form-group">
              <label for="party-wphone" class="form-label">Work Phone</label>
              <input type="text" class="form-control" id="party-wphone" v-model="entity.workPhone"/>
            </div>
            <div class="form-group">
              <label for="party-skype" class="form-label">Skype</label>
              <input type="text" class="form-control" id="party-skype" v-model="entity.skype"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="charge-profile" class="form-label">Charge Profile</label>
              <select class="form-control" id="charge-profile" v-model="entity.chargeProfile">
                <option value=""></option>
                <option v-for="(opt) in chargeProfiles" :key="opt.id" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="pay-cur" class="form-label">Payment Currency</label>
              <select class="form-control" id="pay-cur" v-model="entity.paymentCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="party-prov" class="form-label">Provider type</label>
              <select class="form-control" id="party-prov" v-model="entity.providerType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('VENDOR_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="party-aw" class="form-label">Operational region</label>
              <select class="form-control" id="party-wa" v-model="entity.operationalRegion">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('WORLD_AREA')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="party-brand" class="form-label">Brand</label>
              <select class="form-control" id="party-brand" v-model="entity.brand">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('BRAND')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="party-ext" class="form-label">External Id</label>
              <input type="text" class="form-control" id="party-ext" v-model="entity.externalId"/>
            </div>
            <div class="form-group">
              <label for="party-ext2" class="form-label">SCAC</label>
              <input type="text" class="form-control" id="party-ext2" v-model="entity.externalId2"/>
            </div>
            <div class="form-group">
              <label for="party-duns" class="form-label">DUNS</label>
              <input type="text" class="form-control" id="party-duns" v-model="entity.duns"/>
            </div>
            <div class="form-group">
              <label for="party-oos" class="form-label">Out of service?</label>
              <div class="material-switch">
                <input id="party-oos" type="checkbox" v-model="entity.outOfService"/>
                <label for="party-oos" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="party-cn" class="form-label">Disallow consolidated service?</label>
              <div class="material-switch">
                <input id="party-cn" type="checkbox" v-model="entity.disallowConsolidatedService"/>
                <label for="party-cn" class="label-success"></label>
              </div>
            </div>
            <!--
              <div class="form-group">
                <label for="party-fa" class="form-label">Federate Assignees?</label>
                <div class="material-switch">
                  <input id="party-fa" type="checkbox" v-model="entity.federatedAssignees"/>
                  <label for="party-fa" class="label-success"></label>
                </div>
              </div>
              <div class="form-group">
                <label for="party-hr" class="form-label">Federate HR Users?</label>
                <div class="material-switch">
                  <input id="party-hr" type="checkbox" v-model="entity.federatedHRUsers"/>
                  <label for="party-hr" class="label-success"></label>
                </div>
              </div>
            -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import HelperMixin from '../../mixins/Helpers'
  import API from '../../../../api/endpoints'
  export default {
    name: 'Party',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      Autocomplete
    },
    data () {
      return {
        transformForUpdate: {
          partyGroup: this.toMinus,
          partySubgroup: this.toMinus,
          status: this.toMinus,
          reportingGroup: this.toMinus,
          headOffice: this.toMinus,
          bankDetails: this.toMinus,
          workflow: this.toMinus,
          caseManager: this.toMinus,
          accountManager: this.toMinus,
          providerType: this.toMinus,
          qualityScore: this.toZero,
          preferenceScore: this.toZero,
          debtor: this.toMinus,
          creditor: this.toMinus,
          operationalRegion: this.toMinus,
          address: this.toMinus,
          brand: this.toMinus,
          paymentCurrency: this.toMinus,
          chargeProfile: this.toMinus
        },
        newEntityScreen: 'Admin - Parties',
        editEntityScreen: 'Admin - Edit/View Party',
        tab: 'main',
        boxes: [
          {
            prop: 'paymentCurrency',
            id: 'id'
          },
          {
            prop: 'providerType',
            id: 'id'
          },
          {
            prop: 'operationalRegion',
            id: 'id'
          },
          {
            prop: 'brand',
            id: 'id'
          },
          {
            prop: 'reportingGroup',
            id: 'id'
          },
          {
            prop: 'status',
            id: 'id'
          },
          {
            prop: 'partyGroup',
            id: 'id'
          },
          {
            prop: 'partySubgroup',
            id: 'id'
          },
          {
            prop: 'chargeProfile',
            id: 'id'
          }
        ],
        entity: {
          id: null,
          code: null,
          name: null,
          partyGroup: null,
          partySubgroup: null,
          category: null,
          status: null,
          reportingGroup: null,
          headOffice: null,
          bankDetails: null,
          duns: null,
          workflow: null,
          stylesheet: null,
          outOfService: null,
          caseManager: null,
          accountManager: null,
          federatedHRUsers: null,
          federatedAssignees: null,
          qualityScore: null,
          preferenceScore: null,
          providerType: null,
          externalId: null,
          externalId2: null,
          taxNumber: null,
          debtor: null,
          creditor: null,
          operationalRegion: null,
          disallowConsolidatedService: null,
          email: null,
          workPhone: null,
          mobilePhone: null,
          skype: null,
          fax: null,
          website: null,
          address: null,
          brand: null,
          paymentCurrency: null,
          chargeProfile: null
        },
        entityName: 'party'
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name && this.entity.category &&
          this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0
      },
      partyGroups () {
        return this.$store.getters['systemOption/partyGroups']
      },
      addresses () {
        return this.locationSearchResults.filter(({category}) => category === 'ADDRESS')
      },
      chargeProfiles () {
        return this.$store.getters['systemOption/chargeProfiles']
      }
    },
    methods: {
      initData () {
        for (let prop in this.baseEntity) {
          this.entity[prop] = this.baseEntity[prop]
        }
        // this.findAddress()
        this.unbox()
      },
      findAddress () {
        if (this.baseEntity.address !== null) {
          this.$http.get(API.GET_ADMIN_ENTITY_BY_ID('location', this.baseEntity.address.id))
            .then(({data}) => {
              this.entity.address = data || ''
            })
            .catch((err) => {
              console.log(err)
            })
        }
      },
      selectAddress (d) {
        this.entity.address = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      displayLocation (location) {
        let str = ''
        if (location.address) {
          str += location.address
        }
        if (location.name) {
          str += `, ${location.name}`
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      updateLocationSearchResults (str) {
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('location'), { params: { address: str, category: 'ADDRESS' } })
          .then(({data}) => {
            if (str === this.locationSearchText) {
              this.$store.dispatch('quote/mapLocationsWithCountry', data)
              .then(res => {
                this.locationSearchResults = res
              })
              .catch(err => {
                console.log(err)
                this.locationSearchResults = data
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          partyGroup: null,
          partySubgroup: null,
          category: null,
          status: null,
          reportingGroup: null,
          headOffice: null,
          bankDetails: null,
          duns: null,
          workflow: null,
          stylesheet: null,
          outOfService: null,
          caseManager: null,
          accountManager: null,
          federatedHRUsers: null,
          federatedAssignees: null,
          qualityScore: null,
          preferenceScore: null,
          providerType: null,
          externalId: null,
          externalId2: null,
          taxNumber: null,
          debtor: null,
          creditor: null,
          operationalRegion: null,
          disallowConsolidatedService: null,
          email: null,
          workPhone: null,
          mobilePhone: null,
          skype: null,
          fax: null,
          website: null,
          address: null,
          brand: null,
          paymentCurrency: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Party/Party.vue